import {
  type SaveTaskType,
  TaskTypeListSchema,
  TaskTypeSchema,
} from "@recobra/schemas/task-catalog";

import { requestJson, requestVoid } from "./client";

const taskTypePath = (id: string) => `/admin/task-types/${encodeURIComponent(id)}`;

export const taskCatalogApi = {
  list: () => requestJson("/task-types", TaskTypeListSchema),
  save: (id: string, input: SaveTaskType) =>
    requestJson(taskTypePath(id), TaskTypeSchema, { method: "PUT", body: JSON.stringify(input) }),
  delete: (id: string, expectedRevision: number) =>
    requestVoid(
      `${taskTypePath(id)}?${new URLSearchParams({ expectedRevision: String(expectedRevision) })}`,
      {
        method: "DELETE",
      },
    ),
};
